import React from 'react';
import { PageBreakBlock } from '../../ast/document.types';

interface PageBreakBlockRendererProps {
  block: PageBreakBlock;
}

export const PageBreakBlockRenderer: React.FC<PageBreakBlockRendererProps> = () => {
  return (
    <div
      className="doc-page-break"
      style={{
        margin: '24px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#9ca3af',
        userSelect: 'none',
      }}
    >
      <div style={{ flex: 1, height: '1px', borderTop: '1px dashed #cbd5e1' }} />
      <span style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>
        Page Break
      </span>
      <div style={{ flex: 1, height: '1px', borderTop: '1px dashed #cbd5e1' }} />
    </div>
  );
};
